export const HEARTBEAT_STALE_MS = 90_000;

export function isHeartbeatStale(
  status: string,
  heartbeatAt: string | null | undefined,
  nowMs: number = Date.now(),
): boolean {
  if (status !== "running") return false;
  if (!heartbeatAt) return false;
  const ts = Date.parse(heartbeatAt);
  if (!Number.isFinite(ts)) return false;
  return nowMs - ts > HEARTBEAT_STALE_MS;
}

const ERROR_CODE_LABELS: Record<string, string> = {
  job_timeout: "Job timeout",
  oom: "Out of memory",
  insufficient_time_limit: "Insufficient time limit",
  cancelled: "Cancelled",
  handler_error: "Handler error",
  worker_lost: "Worker lost",
};

export function errorCodeLabel(code: string): string {
  return ERROR_CODE_LABELS[code] ?? code;
}

export type ErrorCodeEmphasis = "rose" | "neutral";

export function errorCodeEmphasis(code: string): ErrorCodeEmphasis {
  return code === "worker_lost" ? "rose" : "neutral";
}
